  
 

  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>link</mat-icon></span>
      {{title}}     
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>    
  </h2>
  
<mat-dialog-content class="mat-typography">
  <mat-form-field class="example-full-width">
      <mat-label>{{title}} </mat-label>
     <textarea
        matInput
        cdkTextareaAutosize
        cdkAutosizeMinRows="3"
        cdkAutosizeMaxRows="8"
        placeholder="Add URL"
        [(ngModel)]="successUrl"
        (input)="onSuccessURLChange($event.target.value)">
      </textarea>
      
  </mat-form-field>
  <div *ngIf="showSuccessUrlMessage==true" style="color: red;">Invalid URL</div>
  
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" [disabled]="successUrl=='' " 
  (click)="addUpdateFolderUrl()">Add
  <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
  </mat-spinner></mat-icon>
</button>
</mat-dialog-actions>









